//node modules
import { Routes, Route } from "react-router-dom";
import AOS from "aos";

//Components
import MainPage from "./pages/Main";
import { Toaster } from "react-hot-toast";
import "aos/dist/aos.css";

function App() {
  AOS.init({
    delay: 200,
    once: true,
  });

  return (
    <div className="App">
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 7000,
        }}
      />
      <MainPage />
    </div>
  );
}

export default App;
